import { Injectable } from '@angular/core';
import { RolesIdsEnum } from 'app/_models/roles';
import { User } from 'app/_models/user';
import { SettingsService } from './settings.service';
import { MixPanelEventEnum } from 'app/_models/mixPanelEventEnum';

@Injectable({ providedIn: 'root' })
export class MixPanelService {
    constructor(private config: SettingsService) { }

    public incrementUserPropertiesMixPanel(properties: object) {
        return this.config.executePut({ url: '/general/mixpanel/increment-user-properties', body: properties} );
    }

    public updateUserPropertiesMixPanel(user: User) {
        let properties = {
            "First Name": user.firstName,
            "Company": user.current_company_name,
            "Email": user.email,
            "Role": RolesIdsEnum[user.role],
            "Status": "Ativo"
        };
        return this.config.executePut({ url: '/general/mixpanel/update-user-properties', body: properties} );
    }

    public trackMixPanelEvent(mixPanelEvent: MixPanelEventEnum, data: any = null) {
        let body = { mixPanelEvent: mixPanelEvent, data };
        return this.config.executePost({ url: '/general/mixpanel/track-event', body: body });
    }
}
